import React, { Component } from 'react';
import LayoutHeader from './Header.style';
import { AdditionalHeaderInformation } from 'Component/AdditionalHeaderInformation/AdditionalHeaderInformation';
import Clock from 'Component/Clock/Clock';
import LoggedInAs from 'Component/LoggedInAs/LoggedInAs';
import {getUserRole, isGhostUser} from "Redux/Query";
import {connect} from "react-redux";
import {GHOST_USER, handbookUrl} from "AppConfig/Config";

class Header extends React.Component {
    render() {

        return (
            <LayoutHeader>
                <AdditionalHeaderInformation />
                <Clock />
                <LoggedInAs skeleton={ this.props.skeleton } />
                <a href={ handbookUrl[this.props.isGhostUser ? GHOST_USER : this.props.role] || handbookUrl.default } target={"_blank"}>Handbuch</a>
            </LayoutHeader>
        );
    }
}


const mapStateToProps = (state) => ({
    role: getUserRole(state),
    isGhostUser: isGhostUser(state),
});

export default connect(mapStateToProps)(Header);
